<div class="collection-container">
  <div class="collection-header">
    <hyperkit-typography
      variant="emphasized"
      size="sm"
      align="left"
      color="inactive"
      >Collection</hyperkit-typography
    >
    <hyperkit-typography variant="h5" align="left" color="primary">{{
      data.collection.title
    }}</hyperkit-typography>

    <div class="collection-meta">
      <div class="date">
        <hyperkit-badge variant="neutral" text="Created"></hyperkit-badge>
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{
            data.collection.created_date | date: 'longDate'
          }}</hyperkit-typography
        >
      </div>
      <div class="date">
        <hyperkit-badge variant="neutral" text="Updated"></hyperkit-badge>
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{
            data.collection.last_updated | date: 'longDate'
          }}</hyperkit-typography
        >
      </div>
    </div>

    <div class="options">
      @if (huntCompatible) {
        <span>
          @if (huntModuleAccess) {
            <span>
              <hyperkit-button-menu
                variant="standard"
                iconPosition="right"
                color="tertiary"
                size="small"
                icon="chevron-down"
                text="Hunt"
              >
                <hyperkit-dropdown-menu-item
                  (click)="addToExistingTemplate()"
                  value="archive"
                  label="Existing Hunt Template"
                ></hyperkit-dropdown-menu-item>
                <hyperkit-dropdown-menu-item
                  (click)="addToExistingQuickHunt()"
                  value="update"
                  label="Existing Hunt"
                ></hyperkit-dropdown-menu-item>
                <hyperkit-dropdown-menu-item
                  (click)="addToNewTemplate()"
                  value="archive"
                  label="New Hunt Template"
                ></hyperkit-dropdown-menu-item>
                <hyperkit-dropdown-menu-item
                  (click)="addToNewQuickHunt()"
                  value="update"
                  label="New Hunt"
                ></hyperkit-dropdown-menu-item>
              </hyperkit-button-menu>
            </span>
          } @else {
            <hyperkit-button
              (click)="openHuntDialog()"
              size="small"
              text="Hunt"
              color="secondary"
              [customImage]="'/assets/img/icons/cyborg-premium.png'"
              [variant]="'standard'"
            ></hyperkit-button>
          }
        </span>
      }
    </div>
  </div>

  <cyborg-section class="main-section">
    <div class="collection-content">
      <div class="content-panel">
        <div class="threat-summary">
          <collection-header>
            <hyperkit-markdown
              [md]="data.collection.threat_summary"
            ></hyperkit-markdown>
          </collection-header>
        </div>
      </div>

      <div class="tabs-panel">
        <hyperkit-tab-bar
          class="collections-tabs"
          variant="primary"
          mode="underline"
        >
          @if (data.huntPackages && data.huntPackages.length !== 0) {
            <hyperkit-tab text="Hunt Packages" [selected]="true">
              @for (huntPackage of data.huntPackages; track huntPackage) {
                <div class="hp-list">
                  <div class="header">
                    <cyborg-trial-lock-unlock
                      [huntPackage]="huntPackage"
                    ></cyborg-trial-lock-unlock>
                    <hyperkit-badge
                      [variant]="huntPackage.severity | severityBadge"
                      indicator="dot"
                      size="large"
                      [text]="huntPackage.severity"
                    >
                    </hyperkit-badge>
                  </div>
                  <div class="hunt-package-meta">
                    <div class="date">
                      <hyperkit-badge
                        variant="neutral"
                        text="Created"
                      ></hyperkit-badge>
                      <hyperkit-typography
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >{{
                          huntPackage.created_date | date: 'longDate'
                        }}</hyperkit-typography
                      >
                    </div>
                    <div class="date">
                      <hyperkit-badge
                        variant="neutral"
                        text="Updated"
                      ></hyperkit-badge>
                      <hyperkit-typography
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >{{
                          huntPackage.last_updated | date: 'longDate'
                        }}</hyperkit-typography
                      >
                    </div>
                  </div>
                  <div class="hunt-package-meta">
                    @if (huntPackage.dependencies.length !== 0) {
                      <div class="deps">
                        <hyperkit-badge
                          variant="neutral"
                          text="Dependencies"
                        ></hyperkit-badge>
                        <hyperkit-typography
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >{{
                            huntPackage?.dependencies.join(', ')
                          }}</hyperkit-typography
                        >
                      </div>
                    }
                  </div>
                  <hyperkit-typography
                    variant="body"
                    size="md"
                    align="left"
                    color="body"
                    [wrap]="true"
                    wordBreak="break-word"
                    >{{ huntPackage.description }}</hyperkit-typography
                  >
                </div>
              }
            </hyperkit-tab>
          }

          <hyperkit-tab text="Details">
            <div class="details-content">
              <hyperkit-markdown
                [md]="data.collection.synopsis"
              ></hyperkit-markdown>
            </div>
          </hyperkit-tab>

          @if (data.threatProfiles && data.threatProfiles.length !== 0) {
            <hyperkit-tab text="Threat Profiles">
              @for (threatProfile of data.threatProfiles; track threatProfile) {
                <div class="threat-profile-item">
                  <div class="header">
                    <hyperkit-link
                      variant="h5"
                      color="primary"
                      [text]="threatProfile.profile_name"
                      [routerLink]="[
                        '/research/threat-profile',
                        threatProfile.UUID,
                      ]"
                    ></hyperkit-link>
                    <hyperkit-badge
                      [variant]="threatProfile.impact[0] | severityBadge"
                      indicator="dot"
                      size="large"
                      [text]="threatProfile.impact[0]"
                    >
                    </hyperkit-badge>
                  </div>
                  <div class="hunt-package-meta">
                    @if (
                      threatProfile.also_known_as &&
                      threatProfile.also_known_as.length !== 0
                    ) {
                      <div class="date">
                        <hyperkit-badge
                          variant="neutral"
                          text="Also Known As"
                        ></hyperkit-badge>
                        <hyperkit-typography
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >{{
                            threatProfile.also_known_as.join(', ')
                          }}</hyperkit-typography
                        >
                      </div>
                    }
                    @if (
                      threatProfile.context.motivations &&
                      threatProfile.context.motivations.length !== 0
                    ) {
                      <div class="date">
                        <hyperkit-badge
                          variant="neutral"
                          text="Motivations"
                        ></hyperkit-badge>
                        <hyperkit-typography
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >{{
                            threatProfile.context.motivations.join(', ')
                          }}</hyperkit-typography
                        >
                      </div>
                    }
                  </div>
                  <div class="hunt-package-meta">
                    @if (
                      threatProfile.targeting && threatProfile.targeting !== ''
                    ) {
                      <div class="deps">
                        <hyperkit-badge
                          variant="neutral"
                          text="Targeting"
                        ></hyperkit-badge>
                        <hyperkit-typography
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >{{ threatProfile?.targeting }}</hyperkit-typography
                        >
                      </div>
                    }
                  </div>
                  <hyperkit-typography
                    variant="body"
                    size="md"
                    align="left"
                    color="body"
                    >{{ threatProfile.overview }}</hyperkit-typography
                  >
                </div>
              }
            </hyperkit-tab>
          }
        </hyperkit-tab-bar>
      </div>
    </div>
  </cyborg-section>

  <cyborg-section class="tags-section">
    <cyborg-content-section>
      <div class="tags-container">
        <collection-header>
          <cyborg-facet-buttons
            class="tile-facets"
            [facets]="tags"
            [groupByCategory]="true"
          ></cyborg-facet-buttons>
        </collection-header>
      </div>
    </cyborg-content-section>
  </cyborg-section>
</div>
